<template>
    <div>
        <div class="flex flex-col sm:flex-row items-center mt-3">
            <label class="w-full sm:w-20 sm:text-right sm:mr-5">Rol</label>

            <select v-model="selectedRol" class="input w-full border my-3 flex-1" @change="obtenerPermisos(selectedRol)">
                <option value="0" selected>Selecciona un Rol</option>
                <option v-for="rol in roles" :value="rol.id">
                    {{rol.name}}
                </option>
            </select>

            <button type="button" class="button bg-theme-1 sm:ml-16 text-white" @click="actualizarPermisos" :disabled="selectedRol == 0">Actualizar Permisos</button>

        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">

            <div v-for="(permisos , category) in permisosPorCategoria" class="p-5 border border-8 bg-white rounded-lg">
                <strong class="uppercase mb-4">{{category}}</strong>
                <div v-for="item in permisos" class="mt-3 flex">
                    <div class="mr-4">
                        <input type="checkbox" class="input input--switch border" name="permisos[]" v-model="item.checked" :value="item.id">
                    </div>
                    <label><strong>{{ item.name }}</strong></label>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            roles: Array
        },
        data() {
            return {
                permisos: null,
                selectedRol: 0,
            }
        },
        mounted() {
            this.obtenerPermisos();
        },
        computed: {
            permisosPorCategoria() {
                return _.groupBy(this.permisos, 'category')
            }
        },
        methods: {
            obtenerPermisos(rol){
                this.$req.rol.getPermisos(rol).then(async res => {
                    this.permisos = res.data;
                }).catch(err => {
                    console.log('error:' + err)
                })
            },
            getPermisosSeleccionados(){
                let permisosSeleccionados = [];
                this.permisos.forEach(function (perm) {
                    if(perm.checked){
                        permisosSeleccionados.push(perm.id);
                    }
                });
                return permisosSeleccionados;
            },
            actualizarPermisos(){

                let data = {
                    rol_id: this.selectedRol,
                    permisos: this.getPermisosSeleccionados()
                };

                this.$req.rol.updatePermisos(data).then(async res => {
                    if(res.data.result === "ok"){
                        $.toast({
                            heading: '¡Éxito!',
                            text: res.data.message,
                            showHideTransition: 'fade',
                            icon: 'success',
                            position: 'bottom-right',
                        });
                    }
                }).catch(err => {
                    $.toast({
                        heading: 'Error',
                        text: err.message,
                        showHideTransition: 'fade',
                        icon: 'error',
                        position: 'bottom-right',
                    });
                })
            },

        }
    }
</script>
